import React from "react";
import {
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";

interface UnsavedChangesAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

const UnsavedChangesAlert: React.FC<UnsavedChangesAlertProps> = ({
  isOpen,
  onClose,
  onExit,
}) => {
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Unsaved Changes
          </AlertDialogHeader>

          <AlertDialogBody>
            You have unsaved changes. Are you sure you want to exit editing
            mode?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={onClose}
              size={"md"}
              variant={"outline"}
            >
              Continue Editing
            </Button>
            <Button variant={"destructive"} size={"md"} onClick={onExit} ml={3}>
              Exit
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default UnsavedChangesAlert;
